module.exports = __webpack_public_path__ + "static/img/A55.ccd921f9.jpg";